import { SidePanel, Button } from '../../merchant/ui/primitives.js';
import type { SavedBrief } from './savedBriefApi.js';
export function SavedBriefDrawer({
  brief,
  versions,
  currentVersionId,
  language,
  onClose,
  onVersion,
}: {
  brief: SavedBrief;
  versions: SavedBrief[];
  currentVersionId: string;
  language: 'en' | 'ar';
  onClose: () => void;
  onVersion: (id: string) => void;
}) {
  const ar = language === 'ar';
  const ordered = [...versions].sort((a, b) => a.versionNumber - b.versionNumber);
  return (
    <SidePanel
      title={brief.title}
      eyebrow={ar ? 'الملخص' : 'Brief'}
      onClose={onClose}
      closeLabel={ar ? 'إغلاق الملخص' : 'Close brief'}
      footer={null}
    >
      <dl className="mj-ws-brief-fields">
        <dt>{ar ? 'الموضوع' : 'About'}</dt>
        <dd dir="auto" className="mj-ws-preserve-text">
          {brief.about}
        </dd>
        <dt>{ar ? 'التعليمات والمراجع' : 'Instructions and references'}</dt>
        <dd dir="auto" className="mj-ws-preserve-text">
          {brief.instructions ?? (ar ? 'لا شيء' : 'None')}
        </dd>
        <dt>{ar ? 'لغة المحتوى' : 'Content language'}</dt>
        <dd>{brief.outputLocale === 'ar' ? 'العربية' : 'English'}</dd>
      </dl>
      <h3 className="mj-ws-h3">{ar ? 'السجل' : 'History'}</h3>
      <ol className="mj-ws-brief-history">
        {ordered.map((v) => (
          <li key={v.versionId}>
            <Button
              variant="secondary"
              className="mj-ws-brief-version"
              disabled={v.versionId === brief.versionId}
              onClick={() => {
                onVersion(v.versionId);
              }}
              aria-current={v.versionId === brief.versionId ? 'true' : undefined}
            >
              <span>
                {ar ? 'الإصدار' : 'Version'} {v.versionNumber}
              </span>
              <time dateTime={v.createdAt}>
                {new Date(v.createdAt).toLocaleDateString(language)}
              </time>
              {v.versionId === currentVersionId && (
                <span className="mj-ws-tag">{ar ? 'الحالي' : 'Current'}</span>
              )}
            </Button>
          </li>
        ))}
      </ol>
    </SidePanel>
  );
}
